// SidebarDataEvaluador.js
import React from "react";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";

export const getSidebarDataEvaluador = () => {
  const cookies = new Cookies();
  const nombre = cookies.get("Nombre") || "Cargando...";
  const hash = cookies.get("hash") || "";

  return [
    {
      title: (
        <>
          <span style={{ fontSize: "18px" }}>{nombre}</span>
        </>
      ),
      path: "#",
      icon: <IoIcons.IoIosPerson />,
    },
    {
      title: "Evaluador",
      path: "/IndexEvaluador/" + hash,
      icon: <IoIcons.IoMdHelpCircle />,
    },
    {
      title: "Instructivos",
      path: "/ManualEvaluador",
      icon: <IoIcons.IoMdBook />,
    },
    {
      title: "",
      path: "/",
      icon: <CerrarSesion />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
  ];
};
